import React from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useEmptyStateStyles } from './empty-state-styles';

interface EmptyStateProps {
  className?: string;
}

export const EmptyState: React.FC<React.PropsWithChildren<EmptyStateProps>> = ({ className, children }) => {
  const classes = useEmptyStateStyles();

  return (
    <div className={mergeClasses('empty-state', classes.root, className)}>
      {children}
    </div>
  );
};
